import { Box, Typography, Paper } from "@mui/material";
import { ChevronRight as ChevronRightIcon } from "@mui/icons-material";
import { BORDER_RADIUS } from "../../../../utils/constants";

const VersionMessage = ({
  content,
  isSelected,
  onSelect,
  isInteractive = true,
}) => {
  return (
    <Box>
      <Paper
        onClick={isInteractive ? onSelect : undefined}
        elevation={0}
        sx={{
          cursor: isInteractive ? "pointer" : "default",
          border: `2px solid ${isSelected ? "rgba(0, 0, 0, 0.4)" : "rgba(0, 0, 0, 0.12)"}`,
          borderRadius: `${BORDER_RADIUS * 4}px`,
          p: 2,
          pl: 1,
          mt: 0.5,
          mb: 0.5,
          transition: "all 0.2s ease",
          ...(isSelected
            ? {
                boxShadow: "0 2px 8px rgba(0, 0, 0, 0.15)",
                bgcolor: "action.selected",
              }
            : {
                boxShadow: "none",
                bgcolor: "transparent",
              }),
          "&:hover": isInteractive
            ? {
                bgcolor: "action.hover",
                borderColor: "rgba(0, 0, 0, 0.3)",
              }
            : {},
        }}
      >
        <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
          <ChevronRightIcon sx={{ fontSize: 18, color: "text.secondary" }} />
          <Typography variant="body2" sx={{ fontWeight: 600 }}>
            {content}
          </Typography>
        </Box>
      </Paper>
    </Box>
  );
};

export default VersionMessage;
